"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _downloadjs = _interopRequireDefault(require("downloadjs"));
var _contentDisposition = _interopRequireDefault(require("content-disposition"));
var _url = require("./utils/url");
var _constants = require("./constants");
var _errors = require("./errors");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var download = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url, filename, mimeType, optional) {
    var formattedUrl, fetchParams, res, disposition, contentType, defaultFileName, defaultMimeType, file;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          formattedUrl = url;
          if ('params' in optional) {
            formattedUrl = (0, _url.formatQueryParams)(url, optional.params);
          }
          fetchParams = {
            method: 'GET',
            mode: 'mode' in optional ? optional.mode : _constants.DEFAULT_CORS_MODE,
            // $FlowFixMe
            headers: 'headers' in optional ? _objectSpread(_objectSpread(_objectSpread({}, _constants.DEFAULT_HEADERS), optional.headers), {}, {
              'Content-Type': mimeType
            }) : _constants.DEFAULT_HEADERS
          };
          _context.prev = 3;
          _context.next = 6;
          return fetch(formattedUrl, fetchParams);
        case 6:
          res = _context.sent;
          if (res.ok) {
            _context.next = 9;
            break;
          }
          throw new _errors.RequestError('', -1);
        case 9:
          disposition = res.headers.get('content-disposition');
          contentType = res.headers.get('content-type');
          defaultFileName = filename;
          if (!defaultFileName) {
            if (disposition) {
              //the parser maybe trigger error
              try {
                defaultFileName = _contentDisposition["default"].parse(disposition).parameters.filename;
              } catch (e) {
                defaultFileName = 'untitled';
              }
            } else {
              defaultFileName = 'untitled';
            }
          }
          defaultMimeType = mimeType || contentType;
          _context.next = 16;
          return res.blob();
        case 16:
          file = _context.sent;
          (0, _downloadjs["default"])(file, defaultFileName, defaultMimeType);
          _context.next = 27;
          break;
        case 20:
          _context.prev = 20;
          _context.t0 = _context["catch"](3);
          if (!(_context.t0 instanceof _errors.RequestError)) {
            _context.next = 26;
            break;
          }
          throw _context.t0;
        case 26:
          throw new _errors.RequestError('', -1);
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 20]]);
  }));
  return function download(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
var _default = exports["default"] = download;
//# sourceMappingURL=download.js.map